'use strict';
eventCodeListingController.$inject = ['$scope', '$q', '$interval', 'reportHelper', 'siteService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('eventCodeListingController', eventCodeListingController);

function eventCodeListingController($scope, $q, $interval, reportHelper, siteService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadSites($scope.vm)]);

	function getViewModel() {
		var model = {
			report: {
				active: null,
				site: { Id: 0, SiteName: 'ALL' },
			},
			sites: [],
			busyMessage: BUSY_MESSAGE.Loading,
			busyPromise: null,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			// Nothing to validate at this time.

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				Active: model.report.active,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
			};

			reportHelper.getReport($scope, '/api/fundreports/eventcodelistingreport', report, 'EventCodeListingReport.pdf');
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				// if there is only one site available then go ahead and select it for the user.
				if (model.sites.length === 1) {
					model.report.site.Id = model.sites[0].Id;
				} else {
					// if there is more than one site available then add an ALL option to the list.
					model.sites.unshift({ Id: 0, SiteName: 'ALL' });
				}
				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadSites: _.partial(loadSites, model),
			openReport: _.partial(openReport, model),
		});
	}
}
